import { styled } from '@mui/material/styles';
import { Outlet } from "react-router-dom";
import { Button, } from '@mui/material';
import { TopNav } from './main-layout/TopNav';
import { SideNav } from './main-layout/SideNav';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';
import { useAuth0 } from '@auth0/auth0-react';
import React from 'react';
import IdleTimerComponent from '../hooks/IdleTimer';
const SIDE_NAV_WIDTH = 240;

const LayoutRoot = styled('div')(({ theme }) => ({
    display: 'flex',
    flex: '1 1 auto',
    maxWidth: '100%',
    [theme.breakpoints.up('lg')]: {
        paddingLeft: SIDE_NAV_WIDTH
    }
}));

const LayoutContainer = styled('div')({
    display: 'flex',
    flex: '1 1 auto',
    flexDirection: 'column',
    width: '100%'
});

export default function MiniDrawer() {
    const [open, setOpen] = React.useState(false);
    const { logout } = useAuth0();
    const user = useSelector((state: RootState) => state.userDetail);
    const onLogout = () => {
        logout({ logoutParams: { returnTo: window.location.origin + '/landing' } });
        localStorage.clear();
    };
    IdleTimerComponent();

    return (
        <>
            {user && user.id > 0 && <TopNav onNavOpen={() => setOpen(true)} />}
            {user && user.id > 0 && <SideNav
                onClose={() => setOpen(false)}
                open={open}
            />}
            {user && user.isActive && <LayoutRoot>
                <LayoutContainer>
                    <Outlet />
                </LayoutContainer>
            </LayoutRoot>}
            {user && user.id > 0 && !user.isActive && <LayoutRoot>
                <LayoutContainer>
                    <h2>{user.message}</h2>
                </LayoutContainer>
            </LayoutRoot>}
            {user && !user.id && !user.isActive && <LayoutRoot>
                <LayoutContainer>
                    <h2>{user.message}</h2>
                    <Button
                        onClick={onLogout}
                        color='primary'
                        variant='contained'
                        sx={{ width: "200px", margin: "0 auto" }}
                    >
                        Logout
                    </Button>
                </LayoutContainer>
            </LayoutRoot>}
        </>
    );
}